module.exports = __webpack_public_path__ + "static/media/Zambia.d2295b0e.png";